import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import getElementLockedStatus from 'utils/getElementLockedStatus'
import { IconAdd } from 'icons'
import ripple from 'react-toolbox/lib/ripple'
import styles from './ActionButton.scss'
import Tooltip from 'components/Tooltip'

class ActionButton extends Component {
  constructor(props) {
    super(props)

    this.state = {
      unlock: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this._updatePosition)
    this._updatePosition()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._updatePosition)
  }

  _updatePosition = () => {
    const end = document.getElementById('footer').clientHeight
    const unlock = getElementLockedStatus(null, end)

    if (this.state.unlock !== unlock) {
      this.setState({ unlock })
    }
  }

  render() {
    const { handleAction, tooltip } = this.props
    const classes = {
      [styles.unlock]: this.state.unlock,
    }

    return (
      <div className={classnames(styles.base, classes)}>
        <a onClick={handleAction} className={styles.button}>
          <IconAdd className={styles.add} width="14" height="14" />
        </a>
        <Tooltip className={styles.tip} tip={tooltip} />
      </div>
    )
  }
}

ActionButton.propTypes = {
  handleAction: PropTypes.func,
  tooltip: PropTypes.string,
}

ActionButton.defaultProps = {
  handleAction: null,
  tooltip: null,
}

export default ripple({ spread: 3 })(ActionButton)



// WEBPACK FOOTER //
// ./src/components/ActionButton/ActionButton.js